module.exports = __webpack_public_path__ + "media/images/Group 16-d98eae3ea32be000dbb7a179af2757d9.png";